// Centralized API configuration - NO HARDCODED ENDPOINTS
// Works with both Railway and Render deployments
const getApiUrl = (): string => {
  const envApiUrl = process.env.REACT_APP_API_URL;
  
  if (!envApiUrl) {
    throw new Error(
      'REACT_APP_API_URL environment variable is required. ' +
      'Please set it in your .env.local file for development, ' +
      'or in your deployment platform configuration.'
    );
  }
  
  return envApiUrl;
};

export const API_URL = getApiUrl();


